const VISIBLE_BADGE_VARIANTS = new Set([
    'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark',
])

// Color de fallback cuando el backend devuelve un valor inválido o claro (ej. "light", "white", vacío).
const FALLBACK_BADGE_VARIANT = 'danger'

/**
 * Normaliza el color de badge que viene del backend al conjunto de variantes de
 * Bootstrap que se ven bien. Si el color no es reconocido, devuelve el fallback.
 */
export const getVisibleStatusColor = (color?: string | null): string => {
    const normalized = (color ?? '').toLowerCase().trim()
    return VISIBLE_BADGE_VARIANTS.has(normalized) ? normalized : FALLBACK_BADGE_VARIANT
}
